// Events DTOs for Analytics Feature

export interface EventFilterRequest {
  apiKey?: string;
  dateFrom?: string; // ISO 8601 format (e.g., "2025-01-10T00:00:00Z")
  dateTo?: string;   // ISO 8601 format (e.g., "2025-01-10T23:59:59Z")
  eventType?: string;
  state?: string;
  city?: string;
  metroCode?: string;
  zipCode?: string;
  trackingNumbers?: string; // Comma-separated tracking numbers
  failureReason?: string; // Failure reason (only for DELIVERY_FAILURE events)
}

export interface EventResponse {
  success: boolean;
  data: EventResponseDto[];
  message?: string;
}

export interface EventResponseDto {
  id: number;
  eventType: string;
  eventTimestamp?: string; // ISO 8601 format
  trackingNumber: string;
  failureReason?: string;
  company: CompanyResponseDto;
  addressTo: AddressResponseDto;
  addressFrom?: AddressResponseDto;
  createdAt: string; // ISO 8601 format
}

export interface CompanyResponseDto {
  id: number;
  name: string;
  apiKey: string;
}

export interface AddressResponseDto {
  id: number;
  street1: string;
  street2?: string;
  city: string;
  state: string;
  zipCode: string;
  metroCode: string;
  latitude?: number;
  longitude?: number;
  addressApiTraceId: string;
}

// Event types enum for type safety
export enum EventType {
  TRANSACTION_CREATED = 'TRANSACTION_CREATED',
  DELIVERED = 'DELIVERED',
  REFUSED = 'REFUSED',
  AWAITING_ADDRESS_CONFIRMATION = 'AWAITING_ADDRESS_CONFIRMATION',
  DELIVERY_FAILURE = 'DELIVERY_FAILURE',
  STOLEN = 'STOLEN',
  CUSTOMER_REFUSED = 'CUSTOMER_REFUSED'
}

// Helper for getting all event types as array
export const EVENT_TYPES = Object.values(EventType);

// Company Dropdown DTO
export interface CompanyDropdownDto {
  id: number;
  name: string;
  apiKey: string;
}

